
    var riot = require('riot')
    //src: starling/src/tags/node-perspective-dots.html
riot.tag2('node-perspective-dots',
  '<node-perspective-dot each="{this.getNodePerspectives()}" dummy="{parent.opts.dummy}"></node-perspective-dot>',
  'node-perspective-dots { font-size: 10px; position: relative; top: -3px; line-height: 1.2em; height: 16px; display: inline-block; border-radius: 12px; padding: 0 12px 0 0; } node-perspective-dots:before { content: " "; position: absolute; left: -2px; right: 4px; top: 0px; bottom: -1px; background: white; z-index: 0; border-radius: 36px; } node-perspective-dots .eyeball-container,[data-is="node-perspective-dots"] .eyeball-container{ position: relative; z-index: 1; }',
  'ref="main" show="{this.getNodePerspectives().length}"', function(opts) {
'use strict';

var _this = this;

var _perspectivesUi = require('lib/perspectives-ui');

var _store_instance = require('../store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.canvas = this.parent.canvas;
this.nodePerspectives = [];
this.node = this.parent.instance;

if (!this.opts.dummy) {
  this.canvas.nodePerspectiveDotsTag[this.parent.id] = this;
}
this.on('update', function () {
  _this.pointPerspective = _this.getPointPerspective();
  _this.refreshAnnotations();
});

this.getDots = function () {
  if (_this.tags['node-perspective-dot'] && _this.tags['node-perspective-dot'].length) {
    return _this.tags['node-perspective-dot'];
  } else if (_this.tags['node-perspective-dot']) {
    return [_this.tags['node-perspective-dot']];
  }
  return [];
};

this.getPointPerspectiveId = function () {
  return _this.pointPerspective ? _this.pointPerspective.id : '0';
};

this._fetchNodePerspectives = function () {
  var pers = _perspectivesUi.pui.getNodePerspectives(_this.node);
  _this.nodePerspectives.length = 0;
  for (var _iterator = pers, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var p = _ref;

    _this.nodePerspectives.push(p);
  }
};

this.getNodePerspectives = function () {
  return _this.nodePerspectives;
};

this.getPointPerspective = function () {
  return _store_instance2.default.getPerspectives().find(function (p) {
    return p.pointNodeUUID == _this.node.id && !p.hidden;
  });
};

this.updateTip = function () {
  return;
  _this.refs.button.setAttribute('data-tip', _this.perspectiveTip());
};

this.perspectiveTip = function () {
  var perspective = _perspectivesUi.pui.getPerspectiveFromPointNode(_this.node.id);
  if (perspective && _perspectivesUi.pui.perspectiveIsActive(perspective)) {
    return 'Unpin';
  }
  return 'Pin';
};

this.showAnnotations = function () {
  var getDot = _this.getDot;

  _this.getNodePerspectives().forEach(function (_ref2) {
    var id = _ref2.id;

    getDot(id).displayAnnotation();
  });
};

this.hideAnnotations = function () {
  var getDot = _this.getDot;

  _this.getNodePerspectives().forEach(function (_ref3) {
    var id = _ref3.id;

    if (!_perspectivesUi.pui.perspectiveIsActive(id)) {
      getDot(id).hideAnnotation();
    }
  });
};

this.refreshAnnotations = function () {
  for (var _iterator2 = _this.getDots(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref4;

    if (_isArray2) {
      if (_i2 >= _iterator2.length) break;
      _ref4 = _iterator2[_i2++];
    } else {
      _i2 = _iterator2.next();
      if (_i2.done) break;
      _ref4 = _i2.value;
    }

    var dot = _ref4;

    var annotation = dot.getAnnotationTag();
    if (annotation) {
      annotation.refreshAnnotation();
    }
    dot.freshen();
  }
};

this.getDot = function (perspectiveId) {
  return _this.canvas.nodePerspectiveDotTags[_this.parent.id + '-' + perspectiveId];
};

this.pointPerspective = this.getPointPerspective();
this._fetchNodePerspectives();
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('node-perspective-dots')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/node-perspective-dots.html
// module id = 643
// module chunks = 0